import { Injectable } from '@angular/core';
import { SchedulerAuthService } from '../../../../common/scheduler/services/auth.service';

const defaultRoles = [
  'Chief',
  'Admin',
  'Filters',
  'FilterAdmin',
  'FilterChief',
  'FilterFontanaAdmin',
  'FilterFontanaChief',
];

@Injectable({
  providedIn: 'root',
})
export class FilterSchedulerAuthService extends SchedulerAuthService {
  rolesAllow = [...defaultRoles];

  addRolesAllow(roles: string[]): boolean {
    return this.lookForRolesNeeded([...this.rolesAllow, ...roles]);
  }

  orderingItems(): boolean {
    return this.lookForRolesNeeded([
      ...defaultRoles,
      'FilterLeader',
      'FilterFontanaLeader',
    ]);
  }

  override allowMovement(): boolean {
    return this.addRolesAllow([
      'FilterOperator',
      'FilterLeader',
      'FilterFontanaLeader',
      'FilterFontanaOperator',
    ]);
  }

  startEndWorkOrder(): boolean {
    return this.addRolesAllow([
      'FilterOperator',
      'FilterLeader ',
      'FilterSupervisor',
    ]);
  }

  override editMachineOperators(): boolean {
    return this.addRolesAllow([
      'FilterOperator',
      'FilterLeader',
      'FilterFontanaLeader',
      'FilterFontanaOperator',
    ]);
  }

  override runningItemOff(): boolean {
    return this.addRolesAllow(['FilterSupervisor']);
  }

  override sendItemToWaitingList(): boolean {
    return this.addRolesAllow([
      'FilterOperator',
      'FilterLeader ',
      'FilterSupervisor',
    ]);
  }

  override eliminateItem(): boolean {
    return false;
  }
  override printQuantityWorkOrderLabel(): boolean {
    return this.addRolesAllow([
      'FilterLeader',
      'FilterSupervisor',
      'FilterEngineer',
    ]);
  }

  canGivePriority(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  canChangePriority(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  /**
   * Roles that should see the scheduler as read-only:
   *  - The existing FilterViewer / FilterFontanaViewer / Viewer roles.
   *  - FiltersQualityControl: a QC inspector role that can REACH the
   *    scheduler view (so they can locate orders to inspect) but must not
   *    interact with it (no drag&drop, no start/end WO, no edits, etc.).
   *    The interaction guards (`allowMovement`, `startEndWorkOrder`,
   *    `editMachineOperators`, etc.) already return false for any role
   *    that isn't explicitly whitelisted, so we only need to:
   *      1. Include it in `onlyViewer()` so view-only UI is rendered.
   *      2. Include it in `showTableList()` so the list/table is visible.
   */
  private readonly viewerOnlyRoles = [
    'FilterViewer',
    'FilterFontanaViewer',
    'Viewer',
    'FiltersQualityControl',
  ];

  onlyViewer(): boolean {
    return (
      this.lookForRolesNeeded(this.viewerOnlyRoles) &&
      !this.roles.find((x) => !this.viewerOnlyRoles.includes(x))
    );
  }

  approvingWorkOrder(): boolean {
    return this.lookForRolesNeeded(['FilterSupervisor', 'Chief']);
  }

  showTableList(): boolean {
    return this.lookForRolesNeeded([...defaultRoles, ...this.viewerOnlyRoles]);
  }
}
